'use client';

import { type VideoStockItemResult } from '@app/(darkHeader)/ai/_shared/_actions/searchLibraryVideos';
import { AiToolkitVideoCard } from '@app/(darkHeader)/ai/_shared/_components/AiToolkitVideoCard/AiToolkitVideoCard';
import { useAiToolkitContext } from '@app/(darkHeader)/ai/_shared/_context/AiToolkitContext';
import { SearchLayout } from '@app/(darkHeader)/ai/_shared/_layouts/SearchLayout';
import { type JSX } from 'react';

import { Icon } from '@videoblocks/design-system';

import { useVideoEditForm } from '../../useVideoEditForm';
import { CurrentVideoEditCta } from './CurrentVideoEditCta';

export const VideoSearchLayout = (): JSX.Element => {
    const { videoSearch, activeTask } = useAiToolkitContext();
    const { results, isLoading, error, hasSearched, currentPage, totalPages, goToPage, setShowSearch } = videoSearch;
    const { formState, onVideoSelect } = useVideoEditForm();
    const isFormDisabled = !!activeTask && activeTask.status === 'inProgress';

    const handleSelect = (item: VideoStockItemResult): void => {
        if (isFormDisabled) return;
        onVideoSelect(item);
        setShowSearch(false);
    };

    return (
        <SearchLayout
            results={results}
            isLoading={isLoading}
            error={error}
            hasSearched={hasSearched}
            currentPage={currentPage}
            totalPages={totalPages}
            goToPage={goToPage}
            noResultsTitle="No matching footage found"
            noResultsIcon={
                <Icon name="video" width={32} aria-hidden="true" className="dark:[&_path]:fill-neutral-dark-1000" />
            }
            banner={<CurrentVideoEditCta />}
            dataTestId="video-search-layout"
            renderCard={(item, aspectRatio) => (
                <AiToolkitVideoCard
                    videoId={String(item.id)}
                    videoUrl={item.previewUrl}
                    posterUrl={item.thumbnailUrl}
                    title={item.title}
                    aspectRatio={aspectRatio}
                    selected={item.contentId === formState.contentId}
                    disabled={isFormDisabled}
                    onSelect={() => handleSelect(item)}
                    onEditWithAiClick={() => handleSelect(item)}
                />
            )}
        />
    );
};
